import React from "react";
import PropTypes from "prop-types";
import { hideModal } from "../../../../usecases/commons/hide-modal";
import { translate } from "../../../../infrastructure/translate/localization";
import CircleButton from "../../commons/CircleButton";
import "./show-detail-employee.scss";
import "./show-delete-employees-modal.scss";

function ShowInvalidCSVModal({ message }) {
  return (
    <div className="modal-container">
      <CircleButton
        className="primary close-modal"
        icon="times"
        handlerClick={() => hideModal()}
      />
      <div className="modal-content">
        <div className="modal-left-line" />
        <span className="message">{translate("upload-csv-error")}</span>
        <span className="message">
          {" "}
          Error: <strong>{message}</strong>
        </span>
        <div className="cob-btn-group center-group">
          <button
            type="button"
            className="cob-btn btn-primary-outline"
            onClick={() => hideModal()}
          >
            {translate("actions.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}

ShowInvalidCSVModal.defaultProps = {};
ShowInvalidCSVModal.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ShowInvalidCSVModal;
